module.exports = __webpack_public_path__ + "static/media/icon-search-blue.9e75d96e.svg";